import React from "react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

const ROLE_STYLES = {
  owner: "bg-indigo-50 text-indigo-700 border-indigo-200",
  admin: "bg-slate-900 text-white border-slate-900",
  researcher: "bg-emerald-50 text-emerald-700 border-emerald-200",
  viewer: "bg-slate-100 text-slate-700 border-slate-200",
  client_viewer: "bg-amber-50 text-amber-800 border-amber-200",
};

export function RoleBadge({ role, className }) {
  const { t } = useTranslation("common");
  const style = ROLE_STYLES[role] || ROLE_STYLES.viewer;
  return (
    <span
      data-testid={`role-badge-${role}`}
      className={cn(
        "inline-flex items-center rounded-full border px-2.5 py-0.5 text-[11px] font-medium uppercase tracking-wider",
        style,
        className
      )}
    >
      {t(`roles.${role}`)}
    </span>
  );
}
